import {assert} from 'assert-ts';
import type {Metadata} from '../types';
import type {MetadataEditAction} from '../metadataEditActionTypes';

export const assertMetadata = (
  metadata: Metadata | undefined,
  action?: MetadataEditAction,
  qualifer?: 'saved' | 'edit',
): Metadata => {
  if (!metadata) {
    assert(
      false,
      qualifer
        ? `assertMetadata (${qualifer}): metadata expected`
        : 'assertMetadata: metadata expected',
      action,
    );
  }

  return metadata;
};
